import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { CataloguesService } from "../catalogues.service";
import { MetaService } from "../meta.service";
import { ModulesService } from "../modules.service";

@Component({
	selector: "affordable-options",
	templateUrl: "./affordable-options.component.html",
	styleUrls: ["./affordable-options.component.css"],
})
export class AffordableOptionsComponent implements OnInit {
	//private catalogs
	cats: any[] = [];
	catCount: number = 0;
	modules: any[] = [];
	modCount: number = 0;

	//inject services
	constructor(private mds: MetaService, private router: Router, private cs: CataloguesService, private ms: ModulesService) {}

	//initialize the component
	ngOnInit(): void {
		this.cats = this.cs.getCatalogList();
		this.catCount = this.cats.length;
		this.modules = this.ms.getModuleList();
		this.modCount = this.modules.length;
	}

	//redirects to download page
	download() {
		this.router.navigate(['/gatekeeper/download']);
	}
}
